module.exports = __webpack_public_path__ + "img/pick3.5f3b162b.png";